export default __webpack_public_path__ + "static/story_corps-3bc77c13e8e00a9de355345d5e4bba6e.svg";